
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonMeMainFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PersonMe"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"middleName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"titleId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photoFileId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactMain"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"preferences"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PreferencesFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"socialAccounts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accountIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linkedAt"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"personPasswordInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passwordExpiresAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"passwordStrength"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minPasswordLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minUppercaseSymbolsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minLowercaseSymbolsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minDigitsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minSpecialSymbolsCount"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"accessList"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"edDriveAccessList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personEntityTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"organisationGroupId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"entityLocations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonEntityAllocationMain"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isStudent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isStaff"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":852}};
    doc.loc.source = {"body":"#import \"./PersonEntityAllocationMainFragment.graphql\"\n#import \"../ContactMainFragment.graphql\"\n#import './PreferencesFragment.graphql'\n\nfragment PersonMeMainFragment on PersonMe {\n  id\n  fullName\n  firstName\n  lastName\n  middleName\n  titleId\n  gender\n  photoUrl\n  photoFileId\n  contacts {\n    ...ContactMain\n  }\n  preferences {\n    ...PreferencesFragment\n  }\n  socialAccounts {\n    id\n    type\n    accountIdentifier\n    linkedAt\n  }\n\n  personPasswordInfo {\n    passwordExpiresAt\n    passwordStrength {\n      id\n      minPasswordLength\n      minUppercaseSymbolsCount\n      minLowercaseSymbolsCount\n      minDigitsCount\n      minSpecialSymbolsCount\n    }\n  }\n  tenantId\n  accessList\n  edDriveAccessList {\n    personEntityTypeId\n    permissions\n  }\n  organisationGroupId\n  entityLocations {\n    ...PersonEntityAllocationMain\n  }\n\n  isStudent\n  isStaff\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./PersonEntityAllocationMainFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("../ContactMainFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require('./PreferencesFragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PersonMeMainFragment"] = oneQuery(doc, "PersonMeMainFragment");
        
